import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectGuard = ({ hasPermission, redirectTo = '/error-404' }) => {
    if (hasPermission) return null;
    return <Redirect to={redirectTo} />;
};

export default RedirectGuard;
